import apiClient from '@/lib/apiClient';
import { buildListParams, extractPaginatedData } from '@/shared/utils/queryUtils';

const BASE = '/admin/blocked-users';

export const blockedUsersApi = {
  list: async (params: any) => {
    const queryParams = buildListParams(params);
    const res = await apiClient.get(BASE, { params: queryParams });
    return extractPaginatedData(res);
  },

  getById: async (id: any) => {
    const res = await apiClient.get(`${BASE}/${id}`);
    return res.data?.data;
  },

  create: async (data: any) => {
    const res = await apiClient.post(BASE, data);
    return res.data?.data;
  },

  delete: async (id: any) => {
    const res = await apiClient.delete(`${BASE}/${id}`);
    return res.data;
  },
};
